import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
// import { accessNested } from 'utils/utils';
import { getCopyWithParams } from 'utils/clientUtils';
import { Link } from 'components/core/link/link';
import s from 'components/shared/regionMismatchModal/changeRegionModal.sss';

const formatUrlWithoutProtocol = url =>
	/^(?:http:\/\/)?(?:www\.)?(.+)$/.exec(url)[1];

// const codeToCountryName = (code, countryNames) => (countryNames && countryNames[code]) || code;

// const getUrl = ({ url }) => url;


export default class ChangeRegionModal extends Component {

	/* LifeCycle
	------------------------*/

	componentWillMount() {
		this.requireRegionCopy();
	}


	/* Data handlers
	------------------------*/

	requireRegionCopy() {
		// TODO: should this be moved to the store because the data will be thrown away on rerender?
		// if (this.dataRequest) return this.dataRequest;
		let regionCode = this.props.userRegionApp.regionCode;


		if (regionCode === 'other') {
			// if we are showing a global popup, then use english
			this.setState({ dynamicCopy: this.props.copy });
			return;
		}
		fetch(this.props.apiRoot + '/app_data/region_mismatch/' + regionCode, {
			method: 'GET',
			headers: {
				Accept: 'application/vnd.api+json',
				'Content-Type': 'application/vnd.api+json'
			}
		}).then(r => r.json()).then(data => {
			this.setState({ dynamicCopy: data.copy });
		}).catch(e => console.error(e));
	}

	getFlagPath(countryCode) {
		return `${this.props.imagePath}/flags/${countryCode}.png`;
	}


	/* Event Handlers
	------------------------*/

	closeHandler = () => {
		// TODO: Save in localstorage, so we don't
		// show again next time user visits platform

		// Update Store to let them know user has dismissed region modal
		Store.emit(actions.SET_USER_REGION_MODAL_DISMISSED);
		// Hide the modal
		Store.emit(actions.HIDE_MODAL);
	};

	/* Render Methods
	------------------------*/


	render() {
		const {
			geo,
			appRegionCode,
			currentApp,
			userRegionApp
		} = this.props;

		const dynamicCopy = this.state.dynamicCopy || {};

		// Copy
		const titleCopy = getCopyWithParams({
			LOCATION: geo.city,
			REGION: geo.city
		}, dynamicCopy.$REGION_MISMATCH_MODAL_MAIN || '');
		const subTitleCopy = getCopyWithParams({}, dynamicCopy.$REGION_MISMATCH_MODAL_SECONDARY || '');
		const stayCopy = getCopyWithParams({
			APP_URL: formatUrlWithoutProtocol(currentApp.url)
		}, dynamicCopy.$REGION_MISMATCH_MODAL_STAY || '');

		let userRegionUrl = userRegionApp.url;

		if (window.location && window.location.search) {
			userRegionUrl += '/' + window.location.search;
		}

		return (
			<div class={s.modalBox}>
				{/* Modal Location Bar */}
				<div class={s.locationBar}>
					<div class={s.locationBarTitle}>
						<img
							src={this.getFlagPath(this.props.appCountryCode)}
							alt={this.props.appCountryCode}
						/>
						{/* NOTE: This line needs to be wrapped in span due to this
							Preact Bug: https://github.com/developit/preact/issues/430 */}
						<span>
							{formatUrlWithoutProtocol(currentApp.url)}
						</span>
					</div>

					<button
						class={s.closeModalButton}
						onClick={this.closeHandler}
					/>
				</div>
				<div class={s.contentBox}>
					<h1 class={s.heading}>
						{titleCopy}
					</h1>
					<hr class={s.line} />
					<p class={s.info}>{subTitleCopy}</p>
					<div class={s.gotoButtonContainer}>
						<img src={this.getFlagPath(geo.countryCode)} alt="" />
						<Link
							class={s.gotoButton}
							href={userRegionUrl}
							trackId="geo-region-redirect"
							trackLabel={appRegionCode}
						>
							{formatUrlWithoutProtocol(userRegionApp.url)}
							<div class={s.arrowRight} />
						</Link>
					</div>

					<div class={s.remainLinkBox}>
						<button onClick={this.closeHandler} class={s.remainLink}>
							{stayCopy}
						</button>
					</div>
				</div>
			</div>
		);
	}
}
